/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TermsAndConditionsIndexRouteImport } from './routes/terms-and-conditions/index'
import { Route as RequestExamplesIndexRouteImport } from './routes/request-examples/index'
import { Route as ProposalIndexRouteImport } from './routes/proposal/index'
import { Route as PrivacyPolicyIndexRouteImport } from './routes/privacy-policy/index'
import { Route as PhilanthropyIndexRouteImport } from './routes/philanthropy/index'
import { Route as IntroIndexRouteImport } from './routes/intro/index'
import { Route as HelpIndexRouteImport } from './routes/help/index'
import { Route as FeedbackIndexRouteImport } from './routes/feedback/index'
import { Route as EligibilityIndexRouteImport } from './routes/eligibility/index'
import { Route as ChatIndexRouteImport } from './routes/chat/index'
import { Route as BookingIndexRouteImport } from './routes/booking/index'
import { Route as ArticleIndexRouteImport } from './routes/article/index'
import { Route as ProfileSurveyPermissionsRouteImport } from './routes/profile/survey-permissions'
import { Route as ProfileFeedbackRouteImport } from './routes/profile/feedback'
import { Route as ProfileDeleteAccountRouteImport } from './routes/profile/delete-account'
import { Route as ProfileBenefitsRouteImport } from './routes/profile/benefits'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsAndConditionsIndexRoute = TermsAndConditionsIndexRouteImport.update({
  id: '/terms-and-conditions/',
  path: '/terms-and-conditions/',
  getParentRoute: () => rootRouteImport,
} as any)
const RequestExamplesIndexRoute = RequestExamplesIndexRouteImport.update({
  id: '/request-examples/',
  path: '/request-examples/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProposalIndexRoute = ProposalIndexRouteImport.update({
  id: '/proposal/',
  path: '/proposal/',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyIndexRoute = PrivacyPolicyIndexRouteImport.update({
  id: '/privacy-policy/',
  path: '/privacy-policy/',
  getParentRoute: () => rootRouteImport,
} as any)
const PhilanthropyIndexRoute = PhilanthropyIndexRouteImport.update({
  id: '/philanthropy/',
  path: '/philanthropy/',
  getParentRoute: () => rootRouteImport,
} as any)
const IntroIndexRoute = IntroIndexRouteImport.update({
  id: '/intro/',
  path: '/intro/',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpIndexRoute = HelpIndexRouteImport.update({
  id: '/help/',
  path: '/help/',
  getParentRoute: () => rootRouteImport,
} as any)
const FeedbackIndexRoute = FeedbackIndexRouteImport.update({
  id: '/feedback/',
  path: '/feedback/',
  getParentRoute: () => rootRouteImport,
} as any)
const EligibilityIndexRoute = EligibilityIndexRouteImport.update({
  id: '/eligibility/',
  path: '/eligibility/',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatIndexRoute = ChatIndexRouteImport.update({
  id: '/chat/',
  path: '/chat/',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingIndexRoute = BookingIndexRouteImport.update({
  id: '/booking/',
  path: '/booking/',
  getParentRoute: () => rootRouteImport,
} as any)
const ArticleIndexRoute = ArticleIndexRouteImport.update({
  id: '/article/',
  path: '/article/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileSurveyPermissionsRoute =
  ProfileSurveyPermissionsRouteImport.update({
    id: '/profile/survey-permissions',
    path: '/profile/survey-permissions',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProfileFeedbackRoute = ProfileFeedbackRouteImport.update({
  id: '/profile/feedback',
  path: '/profile/feedback',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileDeleteAccountRoute = ProfileDeleteAccountRouteImport.update({
  id: '/profile/delete-account',
  path: '/profile/delete-account',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileBenefitsRoute = ProfileBenefitsRouteImport.update({
  id: '/profile/benefits',
  path: '/profile/benefits',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/profile/benefits': typeof ProfileBenefitsRoute
  '/profile/delete-account': typeof ProfileDeleteAccountRoute
  '/profile/feedback': typeof ProfileFeedbackRoute
  '/profile/survey-permissions': typeof ProfileSurveyPermissionsRoute
  '/article/': typeof ArticleIndexRoute
  '/booking/': typeof BookingIndexRoute
  '/chat/': typeof ChatIndexRoute
  '/eligibility/': typeof EligibilityIndexRoute
  '/feedback/': typeof FeedbackIndexRoute
  '/help/': typeof HelpIndexRoute
  '/intro/': typeof IntroIndexRoute
  '/philanthropy/': typeof PhilanthropyIndexRoute
  '/privacy-policy/': typeof PrivacyPolicyIndexRoute
  '/proposal/': typeof ProposalIndexRoute
  '/request-examples/': typeof RequestExamplesIndexRoute
  '/terms-and-conditions/': typeof TermsAndConditionsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/profile/benefits': typeof ProfileBenefitsRoute
  '/profile/delete-account': typeof ProfileDeleteAccountRoute
  '/profile/feedback': typeof ProfileFeedbackRoute
  '/profile/survey-permissions': typeof ProfileSurveyPermissionsRoute
  '/article': typeof ArticleIndexRoute
  '/booking': typeof BookingIndexRoute
  '/chat': typeof ChatIndexRoute
  '/eligibility': typeof EligibilityIndexRoute
  '/feedback': typeof FeedbackIndexRoute
  '/help': typeof HelpIndexRoute
  '/intro': typeof IntroIndexRoute
  '/philanthropy': typeof PhilanthropyIndexRoute
  '/privacy-policy': typeof PrivacyPolicyIndexRoute
  '/proposal': typeof ProposalIndexRoute
  '/request-examples': typeof RequestExamplesIndexRoute
  '/terms-and-conditions': typeof TermsAndConditionsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/profile/benefits': typeof ProfileBenefitsRoute
  '/profile/delete-account': typeof ProfileDeleteAccountRoute
  '/profile/feedback': typeof ProfileFeedbackRoute
  '/profile/survey-permissions': typeof ProfileSurveyPermissionsRoute
  '/article/': typeof ArticleIndexRoute
  '/booking/': typeof BookingIndexRoute
  '/chat/': typeof ChatIndexRoute
  '/eligibility/': typeof EligibilityIndexRoute
  '/feedback/': typeof FeedbackIndexRoute
  '/help/': typeof HelpIndexRoute
  '/intro/': typeof IntroIndexRoute
  '/philanthropy/': typeof PhilanthropyIndexRoute
  '/privacy-policy/': typeof PrivacyPolicyIndexRoute
  '/proposal/': typeof ProposalIndexRoute
  '/request-examples/': typeof RequestExamplesIndexRoute
  '/terms-and-conditions/': typeof TermsAndConditionsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/profile/benefits'
    | '/profile/delete-account'
    | '/profile/feedback'
    | '/profile/survey-permissions'
    | '/article/'
    | '/booking/'
    | '/chat/'
    | '/eligibility/'
    | '/feedback/'
    | '/help/'
    | '/intro/'
    | '/philanthropy/'
    | '/privacy-policy/'
    | '/proposal/'
    | '/request-examples/'
    | '/terms-and-conditions/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/profile/benefits'
    | '/profile/delete-account'
    | '/profile/feedback'
    | '/profile/survey-permissions'
    | '/article'
    | '/booking'
    | '/chat'
    | '/eligibility'
    | '/feedback'
    | '/help'
    | '/intro'
    | '/philanthropy'
    | '/privacy-policy'
    | '/proposal'
    | '/request-examples'
    | '/terms-and-conditions'
  id:
    | '__root__'
    | '/'
    | '/profile/benefits'
    | '/profile/delete-account'
    | '/profile/feedback'
    | '/profile/survey-permissions'
    | '/article/'
    | '/booking/'
    | '/chat/'
    | '/eligibility/'
    | '/feedback/'
    | '/help/'
    | '/intro/'
    | '/philanthropy/'
    | '/privacy-policy/'
    | '/proposal/'
    | '/request-examples/'
    | '/terms-and-conditions/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProfileBenefitsRoute: typeof ProfileBenefitsRoute
  ProfileDeleteAccountRoute: typeof ProfileDeleteAccountRoute
  ProfileFeedbackRoute: typeof ProfileFeedbackRoute
  ProfileSurveyPermissionsRoute: typeof ProfileSurveyPermissionsRoute
  ArticleIndexRoute: typeof ArticleIndexRoute
  BookingIndexRoute: typeof BookingIndexRoute
  ChatIndexRoute: typeof ChatIndexRoute
  EligibilityIndexRoute: typeof EligibilityIndexRoute
  FeedbackIndexRoute: typeof FeedbackIndexRoute
  HelpIndexRoute: typeof HelpIndexRoute
  IntroIndexRoute: typeof IntroIndexRoute
  PhilanthropyIndexRoute: typeof PhilanthropyIndexRoute
  PrivacyPolicyIndexRoute: typeof PrivacyPolicyIndexRoute
  ProposalIndexRoute: typeof ProposalIndexRoute
  RequestExamplesIndexRoute: typeof RequestExamplesIndexRoute
  TermsAndConditionsIndexRoute: typeof TermsAndConditionsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms-and-conditions/': {
      id: '/terms-and-conditions/'
      path: '/terms-and-conditions'
      fullPath: '/terms-and-conditions/'
      preLoaderRoute: typeof TermsAndConditionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/request-examples/': {
      id: '/request-examples/'
      path: '/request-examples'
      fullPath: '/request-examples/'
      preLoaderRoute: typeof RequestExamplesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/proposal/': {
      id: '/proposal/'
      path: '/proposal'
      fullPath: '/proposal/'
      preLoaderRoute: typeof ProposalIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy/': {
      id: '/privacy-policy/'
      path: '/privacy-policy'
      fullPath: '/privacy-policy/'
      preLoaderRoute: typeof PrivacyPolicyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/philanthropy/': {
      id: '/philanthropy/'
      path: '/philanthropy'
      fullPath: '/philanthropy/'
      preLoaderRoute: typeof PhilanthropyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/intro/': {
      id: '/intro/'
      path: '/intro'
      fullPath: '/intro/'
      preLoaderRoute: typeof IntroIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help/': {
      id: '/help/'
      path: '/help'
      fullPath: '/help/'
      preLoaderRoute: typeof HelpIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feedback/': {
      id: '/feedback/'
      path: '/feedback'
      fullPath: '/feedback/'
      preLoaderRoute: typeof FeedbackIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eligibility/': {
      id: '/eligibility/'
      path: '/eligibility'
      fullPath: '/eligibility/'
      preLoaderRoute: typeof EligibilityIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat/': {
      id: '/chat/'
      path: '/chat'
      fullPath: '/chat/'
      preLoaderRoute: typeof ChatIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/booking/': {
      id: '/booking/'
      path: '/booking'
      fullPath: '/booking/'
      preLoaderRoute: typeof BookingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/article/': {
      id: '/article/'
      path: '/article'
      fullPath: '/article/'
      preLoaderRoute: typeof ArticleIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/survey-permissions': {
      id: '/profile/survey-permissions'
      path: '/profile/survey-permissions'
      fullPath: '/profile/survey-permissions'
      preLoaderRoute: typeof ProfileSurveyPermissionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/feedback': {
      id: '/profile/feedback'
      path: '/profile/feedback'
      fullPath: '/profile/feedback'
      preLoaderRoute: typeof ProfileFeedbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/delete-account': {
      id: '/profile/delete-account'
      path: '/profile/delete-account'
      fullPath: '/profile/delete-account'
      preLoaderRoute: typeof ProfileDeleteAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/benefits': {
      id: '/profile/benefits'
      path: '/profile/benefits'
      fullPath: '/profile/benefits'
      preLoaderRoute: typeof ProfileBenefitsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProfileBenefitsRoute: ProfileBenefitsRoute,
  ProfileDeleteAccountRoute: ProfileDeleteAccountRoute,
  ProfileFeedbackRoute: ProfileFeedbackRoute,
  ProfileSurveyPermissionsRoute: ProfileSurveyPermissionsRoute,
  ArticleIndexRoute: ArticleIndexRoute,
  BookingIndexRoute: BookingIndexRoute,
  ChatIndexRoute: ChatIndexRoute,
  EligibilityIndexRoute: EligibilityIndexRoute,
  FeedbackIndexRoute: FeedbackIndexRoute,
  HelpIndexRoute: HelpIndexRoute,
  IntroIndexRoute: IntroIndexRoute,
  PhilanthropyIndexRoute: PhilanthropyIndexRoute,
  PrivacyPolicyIndexRoute: PrivacyPolicyIndexRoute,
  ProposalIndexRoute: ProposalIndexRoute,
  RequestExamplesIndexRoute: RequestExamplesIndexRoute,
  TermsAndConditionsIndexRoute: TermsAndConditionsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
